import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import LoadingContext from "../../../../ui/components/LoadingContext/LoadingContext";
import Vendor from "../../../../vendors/components/Vendor";

export default function UserVendors({ user }) {
	const { t } = useTranslation();

	const vendors = Object.entries(user.vendors || {});

	return (
		<>
			<Header as="h3">{t("vendors", "Vendors")}</Header>

			<Card fluid>
				<Card.Content>
					<LoadingContext data={vendors}>
						<Card.Group>
							{vendors.map(([id, vendor]) => {
								return (
									<Card key={id}>
										<Card.Content>
											<Vendor vendor={vendor} />
										</Card.Content>
									</Card>
								);
							})}
						</Card.Group>
					</LoadingContext>
				</Card.Content>
			</Card>
		</>
	);
}
